import { Component, OnInit, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CampaignsReceiptCodeAdminApiClient, GenerateSampleRequest, IGenerateSampleResponse } from 'src/app/api/api-campaigns.service.generated';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSliderModule } from '@angular/material/slider';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { BreadcrumbsComponent, ButtonComponent, PageContainerComponent } from 'wecheer-common';
import { ScreenService } from 'src/app/common/services/screen.service';
import { AppVersionService } from 'src/app/common/services/app-version.service';
import { QRCodeComponent } from 'angularx-qrcode';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-receipt-code-generate-sample',
    templateUrl: './receipt-code-generate-sample.component.html',
    styleUrls: ['./receipt-code-generate-sample.component.scss'],
    imports: [
        MatCardModule,
        MatFormFieldModule,
        MatSliderModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
        CommonModule,
        QRCodeComponent,
        PageContainerComponent,
        BreadcrumbsComponent,
        ButtonComponent
    ]
})
export class ReceiptCodeGenerateSampleComponent implements OnInit {
    private client = inject(CampaignsReceiptCodeAdminApiClient);
    screen = inject(ScreenService);
    appVersion = inject(AppVersionService);

    // Form Controls
    customerCodeControl = new FormControl('1234');
    receiptDateControl = new FormControl('2021-09-05 11:57:28.370');
    invoiceNumberControl = new FormControl('1');
    totalQuantityControl = new FormControl(1);
    qrCodeSizeControl = new FormControl(400);

    responseModel: IGenerateSampleResponse;

    ngOnInit() {
    }

    get loading(): boolean {
        return this.screen.isLoading();
    }

    async generate() {
        this.responseModel = undefined;

        const model = {
            customerCode: this.customerCodeControl.value,
            receiptDate: this.receiptDateControl.value,
            invoiceNumber: this.invoiceNumberControl.value,
            totalQuantity: this.totalQuantityControl.value
        };

        var requestModel = new GenerateSampleRequest(model);
        this.responseModel = await lastValueFrom(this.client.generateSample(requestModel));
    }

    getJson(text: string): object {
        return JSON.parse(text);
    }

    getPreTopMargin(): string {
        const size = this.qrCodeSizeControl.value || 400;
        return `${size / 20 + 5}px`;
    }
}
